export default __webpack_public_path__ + "static/media/django.4c399895.png";